import { useAuth } from 'app/auth/hooks/useAuth';

export const usePathwayId = (): string | undefined => {
  const { meData } = useAuth();
  return meData?.current_pathway?.id;
};
